import { HeadingNode, SerializedHeadingNode } from '@lexical/rich-text';
import { EditorConfig, NodeKey } from 'lexical';

export type SerializedCustomHeadingNode = SerializedHeadingNode & {
  __blockId?: string;
  Modified?: 'true' | 'false' | 'added' | 'removed';
};

export class CustomHeadingNode extends HeadingNode {
  __blockId?: SerializedCustomHeadingNode['__blockId'];
  Modified?: SerializedCustomHeadingNode['Modified'];

  static getType(): string {
    return 'heading';
  }

  static clone(node: CustomHeadingNode): CustomHeadingNode {
    return new CustomHeadingNode(node.getTag(), node.__blockId, node.Modified, node.__key);
  }

  constructor(tag: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6', __blockId?: SerializedCustomHeadingNode['__blockId'], Modified?: SerializedCustomHeadingNode['Modified'], key?: NodeKey) {
    super(tag, key);

    this.__blockId = __blockId;
    this.Modified = Modified;
  }

  exportJSON(): SerializedCustomHeadingNode {
    const json = super.exportJSON() as SerializedCustomHeadingNode;
    if (this.__blockId) {
      json.__blockId = this.__blockId;
    }
    if (this.Modified !== undefined) {
      json.Modified = this.Modified;
    }
    return json;
  }

  static importJSON(serializedNode: SerializedCustomHeadingNode): CustomHeadingNode {
    const node = new CustomHeadingNode(serializedNode.tag, serializedNode.__blockId, serializedNode.Modified);

    // Preserve formatting
    node.setFormat(serializedNode.format || '');
    node.setDirection(serializedNode.direction || null);
    node.setIndent(serializedNode.indent || 0);
    return node;
  }

  createDOM(config: EditorConfig): HTMLElement {
    const dom = super.createDOM(config);

    if (this.__blockId) {
      dom.setAttribute('data-block-id', this.__blockId);
    }

    if (this.Modified === 'true') {
      dom.classList.add('modified-block', 'true');
    } else if (this.Modified === 'added') {
      dom.classList.add('modified-block', 'added');
    } else if (this.Modified === 'removed') {
      dom.classList.add('modified-block', 'removed');
    }

    return dom;
  }

  static importDOM(): Record<string, any> | null {
    return {
      h1: () => ({
        conversion: () => ({ node: new CustomHeadingNode('h1') }),
        priority: 1,
      }),
      h2: () => ({
        conversion: () => ({ node: new CustomHeadingNode('h2') }),
        priority: 1,
      }),
      h3: () => ({
        conversion: () => ({ node: new CustomHeadingNode('h3') }),
        priority: 1,
      }),
      h4: () => ({
        conversion: () => ({ node: new CustomHeadingNode('h4') }),
        priority: 1,
      }),
      h5: () => ({
        conversion: () => ({ node: new CustomHeadingNode('h5') }),
        priority: 1,
      }),
      h6: () => ({
        conversion: () => ({ node: new CustomHeadingNode('h6') }),
        priority: 1,
      }),
    };
  }
} 